import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setStaticPage } from '../static/actions';

import { GamedayLogo } from '../components';

export const StaticPage = ({ page, setStaticPage, noHeader, children, active }) => {
  if (!active) return children;

  setStaticPage(page);
  return (
    <div className='flex-container column center align-center u-full-width'>
      {!noHeader && (
        <div className='mt7-sm mb7-sm border-bottom'>
          <GamedayLogo />
        </div>
      )}
      <div className='pb10-sm border-top-medium-grey u-full-width'>{children}</div>
    </div>
  );
};

StaticPage.propTypes = {
  page: PropTypes.string.isRequired,
  setStaticPage: PropTypes.func.isRequired,
  noHeader: PropTypes.bool,
  children: PropTypes.any,
  active: PropTypes.bool
};

StaticPage.defaultProps = {
  noHeader: false,
  children: null,
  active: true
};

export default connect(() => ({}), {
  setStaticPage
})(StaticPage);
